import { Trans, useTranslation } from "react-i18next"
import intro_artefact from "../img/Intro/Intro_Artefact.png"
import intro_artefactCoutures from "../img/Intro/Intro_ArtefactCoutures.png"
import intro_checkerboard from "../img/Intro/Intro_Checkerboard.png"
import intro_checkerCone from "../img/Intro/Intro_CheckerCone.png"
import intro_checkerConeAuto from "../img/Intro/Intro_CheckerConeAuto.png"
import intro_checkerCube from "../img/Intro/Intro_CheckerCube.png"
import intro_edges from "../img/Intro/Intro_Edges.png"
import intro_faces from "../img/Intro/Intro_Faces.png"
import intro_glasscube from "../img/Intro/Intro_GlassCube.png"
import intro_texturemap from "../img/Intro/Intro_TextureMap.png"
import intro_texturemapAndTex from "../img/Intro/Intro_TextureMapAndTex.png"
import intro_texturemapCylinder from "../img/Intro/Intro_TextureMapCylinder.png"
import intro_vertex from "../img/Intro/Intro_Vertex.png"
export function PageIntro() {
   
    const {t} = useTranslation("pageIntro");
    return (
      <div className="page">
        <h1>{t("introduction")}</h1>
        <div className ="separator" />
        <h2>{t("firstTitle")}</h2>
            <div className="sectionParagraphe-column">
                <Trans ><p>{t("meshContent")}</p></Trans>
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_vertex} alt="Cube with vertex selected"></img>
                        <figcaption>{t("cubeVertex")}</figcaption>
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_edges} alt="Cube with edge selected"></img>
                        <figcaption>{t("cubeEdge")}</figcaption>
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_faces} alt="Cube with face selected"></img>
                        <figcaption>{t("cubeFace")}</figcaption>
                    </figure>
                </div>
            </div>
        <div className ="separator" />
        <h2>{t("secondTitle")}</h2>
            <div className="sectionParagraphe-column">
                <p>{t("geometry")}</p>
                <div className="img-wrapper">
                    <figure className ="img-card">
                       <img src={intro_glasscube} alt="Cube with glass material"></img>
                       <figcaption>{t("glassMat")}</figcaption>
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_checkerCube} alt="Cube with checkered material"></img>
                        <figcaption>{t("checkeredMat")}</figcaption>
                    </figure>
                </div>
            </div>
            <div className="sectionParagraphe-column">
                <Trans><p>{t("howApply")}</p></Trans>
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_checkerboard} alt="Checker texture"></img>
                        <figcaption>{t("checkerTexture")}</figcaption>
                    </figure>
                </div>
            </div>
            <div className="sectionParagraphe-column">
                <Trans><p>{t("uvMap")}</p></Trans>
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_texturemap} alt="UV Map for a cube"></img>
                        <figcaption>{t("uvMapCube")}</figcaption>
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_texturemapAndTex} alt="UV Map for a cube with texture"></img>
                        <figcaption>{t("uvMapCubeTex")}</figcaption>
                    </figure>
                </div>
                <div className="important">
                    <p>{t("unfolded")}</p>
                </div>
            </div>
            <div className="sectionParagraphe-column">
                
                <Trans><p>{t("uvShell")}</p></Trans>
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_texturemapCylinder} alt="UVMap for a cylinder"></img>
                        <figcaption>{t("uvMapCylinder")}</figcaption>
                    </figure>
                </div>
            </div>
        <div className ="separator" />
        <h2>{t("uvMapping")}</h2>
            <div className="sectionParagraphe-column">
                <div>
                    <Trans><p>{t("getUVMap")}</p></Trans>
                    <div className="important">
                        <Trans><p>{t("seamsUV")}</p></Trans>
                    </div>
                    <Trans><p>{t("autoUV")}</p></Trans>
                </div>
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_checkerConeAuto} alt="Cone with auto-generated uv map"></img>
                        <figcaption>{t("uvMapConeAuto")}</figcaption>
                    </figure>
                </div>
            </div>
            <div className="sectionParagraphe-column">
               <p>{t("coneUnfolded")}</p>
                
                <div className="img-wrapper">
                    <figure className ="img-card">
                        <img src={intro_checkerCone} alt="Cone with user-generated uv map"></img>
                        <figcaption>{t("coneUser")}</figcaption>
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_artefact} alt="Examples of artifacts"></img> 
                        <figcaption>{t("artifactsCone")}</figcaption>    
                    </figure>
                    <figure className ="img-card">
                        <img src={intro_artefactCoutures} alt="Seams on cone"></img>
                        <figcaption>{t("seamsCone")}</figcaption>
                    </figure>
                </div>
                <div className="information">
                    <Trans><p>{t("whyArtifacts")}</p></Trans>
                </div>
                <p>{t("hidingSeams")}</p>
            </div>
            <div className ="separator" />
        <h2>{t("thirdTitle")}</h2>
            <div className="sectionParagraphe-column centered">
                <Trans><p>{t("siteGoal")}</p></Trans>
            </div>
            <a href="basics" className="nextButton"> {t("next")}</a>
            <br></br>
        </div>
    );
  }